import React from "react";
import { toast, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

type ToastType = "success" | "error" | "warning" | "info";

interface ToastContent {
  message: string;
  title?: string;
  autoCloseTimer?: number;
}

interface ToastConfig extends ToastOptions {
  autoClose?: number;
  position?:
    | "top-right"
    | "top-center"
    | "top-left"
    | "bottom-right"
    | "bottom-center"
    | "bottom-left";
  pauseOnHover?: boolean;
  draggable?: boolean;
  closeOnClick?: boolean;
  rtl?: boolean;
  hideProgressBar?: boolean;
}

export const showToast = (
  type: ToastType,
  content: ToastContent,
  config?: ToastConfig,
): void => {
  const defaultConfig: ToastConfig = {
    autoClose: content?.autoCloseTimer ? content?.autoCloseTimer : 3000,
    position: "top-right",
    pauseOnHover: true,
    draggable: false,
    closeOnClick: false,
    hideProgressBar: false,
    rtl: false,
    ...config,
  };
  const { message, title } = content;

  const messageComponent: React.ReactNode | string = title ? (
    <div className="msg-container">
      <div className="msg-title">{title}</div>
      <div className="msg-description">{message}</div>
    </div>
  ) : (
    message
  );

  switch (type) {
    case "success":
      toast.success(messageComponent, defaultConfig);
      break;
    case "error":
      toast.error(messageComponent, defaultConfig);
      break;
    case "warning":
      toast.warn(messageComponent, defaultConfig);
      break;
    case "info":
      toast.info(messageComponent, defaultConfig);
      break;
    default:
      toast(message, defaultConfig);
      break;
  }
};
